<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-4 px-8">
        <div class="page text-white">Admin Management</div>
        <div>
          <lms-button @click="$emit('create-admin')">Add Admin</lms-button>
        </div>
      </div>
    </lcontainer>

    <lcontainer>
      <div class="flex justify-between">
        <page-header class="py-2">Admins</page-header>
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput v-model="search" class="py-2" placeholder="Search by Name" />
      </div>
      <admin-table :headers="headers" :items="searchAdmins" class="mb-4" />
      <div />
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    LmsButton: () => import("@/components/general/blue_button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    AdminTable: () => import("@/components/admin/tables/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
  },
  data() {
    return {
      form: {},
      error: {},
      search: "",
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      headers: [
        { key: "name", width: "25%", sortable: true },
        { key: "email", width: "20%", sortable: true },
        {
          key: "gender",
          width: "10%",
          sortable: true,
          shorten: true,
          restrictToLen: 50,
        },
        {
          key: "phone_number",
          width: "15%",
          sortable: true,
          defaultSortBy: true,
          defaultOrder: "DESC",
        },
        {
          key: "role",
          width: "10%",
          sortable: true,
          defaultSortBy: true,
          defaultOrder: "DESC",
        },
        { type: "actions", key: "Actions", width: "20%" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchAdminRoles", "fetchAdmins"]),
  },
  computed: {
    ...mapGetters(["getAdmins"]),
    searchAdmins() {
      return this.getAdmins.filter((admin) => {
        return (
          admin.first_name.toLowerCase().match(this.search.toLowerCase()) ||
          admin.last_name.toLowerCase().match(this.search.toLowerCase())
        );
      });
    },
  },
  mounted() {
    this.fetchAdminRoles();
    this.fetchAdmins();
  },
};
</script>
<style scoped></style>
